import React, { useContext, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import { useLocation } from 'react-router-dom';
import Breadcrumb from "../Generic/Breadcrumb";
import { getPartnerDeatils, getSaluteDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import Partner from "./Partner";
import RofdaMap from "../RofdaMap";

const OurPartners = () => {
  const { appState, dispatch } = useContext(AppContext);
  const { partner, partnerLoader } = appState;
  const myRef = useRef(null);
  const location = useLocation();
  const isHomePage = ["/", "/home", "/*"].includes(location.pathname);

  useEffect(() => {
    getPartnerDeatils(appState, dispatch)
    getSaluteDetails(appState, dispatch)
  }, [])

  const retailer = partner?.section_list?.find(
    (item) => item.parent_page_section_id === "666"
  );

  const wholesaler = partner?.section_list?.find(
    (item) => item.parent_page_section_id === "541"
  );

  return (
    <>
      {
        partnerLoader ?
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
          :
          Object.keys(partner).length &&
          <>
            {!isHomePage &&
              <Breadcrumb
                pageName={partner.header_services_section.title || "our partners"}
                pageTitle={partner.header_services_section.title || "our partners"}
                id={`#${partner.header_services_section.title}`}
                image={partner.header_services_section.banner_image}
                myRef={myRef}
              />
            }

            {/* {
              partner.section_list && partner.section_list.length &&
              partner.section_list.map((section, index) => {
                return (
                  <div ref={myRef}>
                    <Partner partner={section} index={index} />  
                  </div>
                )
              })
            } */}
            {retailer && (<Partner partner={retailer} rtl={false} />)}
            {wholesaler && (<Partner partner={wholesaler} rtl={true} />)}
            {!isHomePage &&
            <RofdaMap />
            }
          </>
      }
    </>
  );
}

export default OurPartners;